'use client';

import banner from '@/assets/images/student-discount/banner.jpg';
import { Accordion, Section } from '@/components/Accordion';
import Button from '@/components/Button';
import CommonBreadcrumbs from '@/components/CommonBreadcrumbs';
import Field from '@/components/Field';
import { fullPageLoadingIndicator } from '@/components/LoadingIndicator';
import TextInput from '@/components/TextInput/textInput';
import Upload from '@/components/Upload';
import useStudentDiscountPage from '@/hooks/StudentDiscountPage/useStudentDiscountPage';
import { isRequired } from '@/util/formValidators';
import { Form } from 'informed';
import Image from 'next/image';
import { Fragment, useEffect, useRef, useState } from 'react';
import classes from './studentDiscountPage.module.css';

import dynamic from 'next/dynamic';

const StudentDiscountAndMilitaryDiscountDialog = dynamic(
  () => import('@/components/StudentDiscountAndMilitaryDiscountDialog'),
  { ssr: false },
);

const StudentDiscountPage = () => {
  const paths = [
    {
      text: 'Home',
      path: '/',
    },
    {
      text: 'student discount',
      path: '/student/discount',
      current: true,
    },
  ];

  const uploadRef = useRef(null);

  const talonProps = useStudentDiscountPage({
    uploadRef,
  });

  const { isLoading, errors, handleSubmit, formApiRef, response } = talonProps;

  const maybeLoadingIndicator = isLoading ? fullPageLoadingIndicator : null;

  const maybeSuccessInfo =
    response && response.code === '200' ? (
      <span className={classes.successInfo}>
        We have received your application and will get back to you via email within 48 hours!
      </span>
    ) : null;

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (response && response.code === '200') {
      setIsOpen(true);
    }
  }, [response]);

  return (
    <Fragment>
      {maybeLoadingIndicator}
      <StudentDiscountAndMilitaryDiscountDialog
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />
      <div className={classes.root}>
        <Image
          src={banner}
          height={500}
          className='hidden h-auto w-full lg_block'
          alt='student discount'
        />
        <div className={classes.contentContainer}>
          <CommonBreadcrumbs paths={paths} />
          <div className={classes.content}>
            <h1 className={classes.title}>12% Off Discounts for Students</h1>
            <p className={classes.subTitle}>Unlock 12% off student discount at kingsyard.com.</p>

            <Form
              className={classes.form}
              onSubmit={handleSubmit}
              formApiRef={formApiRef}
            >
              <div className={classes.twoFieldContainer}>
                <Field
                  id='first-name'
                  label='First Name'
                  required
                >
                  <TextInput
                    autoComplete='firstname'
                    field='firstname'
                    id='firstName'
                    validate={isRequired}
                  />
                </Field>
                <Field
                  id='last-name'
                  label='Last Name'
                  required
                >
                  <TextInput
                    autoComplete='lastname'
                    field='lastname'
                    id='lastName'
                    validate={isRequired}
                  />
                </Field>
              </div>
              <div className={classes.fieldContainer}>
                <Field
                  id='email'
                  label='Email'
                  required
                >
                  <TextInput
                    autoComplete='email'
                    field='email'
                    id='Email'
                    validate={isRequired}
                  />
                </Field>
              </div>
              <div className={classes.fieldContainer}>
                <Field
                  id='photo'
                  label='Photo of your student ID:'
                  classes={{
                    label: classes.uploadLabel,
                  }}
                  required
                >
                  <Upload
                    ref={uploadRef}
                    showUploadList={{
                      showDownloadIcon: false,
                    }}
                    validate={isRequired}
                  />
                  <div className={classes.picadd}>
                    <span>1 image, jpg/png only.</span>
                  </div>
                </Field>
              </div>
              <div className={classes.buttonContainer}>
                <Button
                  type='submit'
                  className={classes.submitButton}
                >
                  Verify Now
                </Button>
              </div>
              {maybeSuccessInfo}
            </Form>

            <Accordion canOpenMultiple>
              <Section
                isOpen
                className={classes.section}
                id={'section-faq'}
                title={'Frequently Asked Questions'}
              >
                <p className={classes.sectionTitle}>Who are eligible for this discount?</p>
                <p>
                  Students who are currently enrolled at a high school, college or university are eligible for the
                  discount
                </p>
                <p className={classes.sectionTitle}>How to verify my identity? </p>
                <p>
                  Verification is quick and simple! Just click the “Verify with ID.me” button and follow the prompts to
                  complete your verification. Sometimes additional documentation is required. Just follow the page
                  guides and it won&lsquo;t take long.
                </p>
                <p className={classes.sectionTitle}>What if I have issues with my ID.me account?</p>
                <p>
                  If you have any issues finishing the verification, please contact their support on If you have any
                  issues finishing the verification, please contact their support on https://help.id.me/hc/en-us for
                  assistance.
                </p>

                <p className={classes.sectionTitle}>Is the student discount eligible for past orders?</p>

                <p>
                  Unfortunately, this discount offer cannot be applied to orders previously placed on kingsyard.com or
                  on other sales channels like Amazon, eBay or Walmart.
                </p>
              </Section>
            </Accordion>

            <Accordion canOpenMultiple>
              <Section
                isOpen
                className={classes.section}
                id={'section-terms'}
                title={'Students Discount Terms and Conditions'}
              >
                <ul className={classes.list}>
                  <li>The discount takes 12% off your order, excluding shipping fees.</li>
                  <li>
                    You can only use one discount code at a time. The discount is only valid for full price items.
                  </li>
                  <li>
                    Coupon is valid for 1 month, and we can only offer one coupon code per valid Student ID within a 6
                    month period.
                  </li>
                  <li>
                    The coupon code must be used on an order that is placed under your name and email address. Orders
                    placed under different names may be cancelled without notice and no additional codes may be offered.
                  </li>
                  <li>Orders you placed before are not eligible for reimbursement.</li>
                  <li>By entering you confirm that you have read and agree to these terms and conditions.</li>
                  <li>
                    All the information will not be collected and stored by xxx.com, we will only use it for
                    verification use.
                  </li>
                  <li>
                    If you have trouble getting the code or if you have any questions, feel free to contact
                    cs@e.kingsyard.com.
                  </li>
                </ul>
              </Section>
            </Accordion>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default StudentDiscountPage;
